import { Clear as IconClearSearch, Search as IconSearch } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
    value: string;
    onChange: (value: string) => void;
};

export default function ReviewPlanSearchInput({ value, onChange }: Props) {
    const { t } = useTranslation("plannerV2");

    return (
        <TextField
            hiddenLabel
            size="small"
            placeholder={t("reviewPlanPanel.searchPlaceholder")}
            value={value}
            onChange={e => onChange(e.target.value)}
            fullWidth
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <IconSearch fontSize="small" />
                        </InputAdornment>
                    ),
                    endAdornment: value && (
                        <InputAdornment position="end">
                            <IconButton size="small" onClick={() => onChange("")}>
                                <IconClearSearch fontSize="small" />
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            }}
        />
    );
}
